
export default {
  data() {
    return {
      deferredPrompt: null,
      showInstallButton: false
    };
  },
  props: {},
  mounted() {
    // 判断是否支持 PWA
    if ("serviceWorker" in navigator && "PushManager" in window) {
      if (window.deferredPrompt) {
        this.deferredPrompt = window.deferredPrompt;
        this.showInstallButton = true;
      } else {
        // 如果beforeinstallprompt这个事件在window.onload后 组件mounted时未触发，则重新建立监听
        window.addEventListener("beforeinstallprompt", (e) => {
          // console.log("page - beforeinstallprompt", e);
          e.preventDefault();
          this.deferredPrompt = e;
          this.showInstallButton = true;
        });
      }
    }
  },
  methods: {
    installPWA() {
      if (this.deferredPrompt) {
        // 触发 PWA 安装提示
        this.deferredPrompt.prompt();
        // 在用户做出选择后，保存结果
        this.deferredPrompt.userChoice.then((choiceResult) => {
          if (choiceResult.outcome === "accepted") {
            console.log("User accepted the A2HS prompt");
          } else {
            console.log("User dismissed the A2HS prompt");
          }
          // 重置 deferredPrompt
          this.deferredPrompt = null;
        });
      }
    },
    randomVideo() {
      dataLayer.push({
        event: "Head_Play"
      });
      const links = document.querySelectorAll('a[href*="/video"]');
      const randomIndex = Math.floor(Math.random() * links.length);
      const randomLink = links[randomIndex];
      randomLink.click();
    }
  }
};
